/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkspacePersona
 */
export interface WorkspacePersona {
    /**
     * Unique identifier of the workspace persona
     * @type {string}
     * @memberof WorkspacePersona
     */
    id: string;
    /**
     * Display name of the workspace
     * @type {string}
     * @memberof WorkspacePersona
     */
    name: string;
    /**
     * URL of the workspace avatar image
     * @type {string}
     * @memberof WorkspacePersona
     */
    avatarUrl: string;
    /**
     * The type discriminator for this persona
     * @type {string}
     * @memberof WorkspacePersona
     */
    type: WorkspacePersonaTypeEnum;
}


/**
 * @export
 */
export const WorkspacePersonaTypeEnum = {
    ChatClientPersona: 'ChatClientPersona',
    ChatAgentPersona: 'ChatAgentPersona',
    WorkspacePersona: 'WorkspacePersona',
    ChatWorkspaceDomainPersona: 'ChatWorkspaceDomainPersona'
} as const;
export type WorkspacePersonaTypeEnum = typeof WorkspacePersonaTypeEnum[keyof typeof WorkspacePersonaTypeEnum];


/**
 * Check if a given object implements the WorkspacePersona interface.
 */
export function instanceOfWorkspacePersona(value: object): value is WorkspacePersona {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('avatarUrl' in value) || value['avatarUrl'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function WorkspacePersonaFromJSON(json: any): WorkspacePersona {
    return WorkspacePersonaFromJSONTyped(json, false);
}

export function WorkspacePersonaFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspacePersona {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'avatarUrl': json['avatarUrl'],
        'type': json['type'],
    };
}

export function WorkspacePersonaToJSON(json: any): WorkspacePersona {
    return WorkspacePersonaToJSONTyped(json, false);
}

export function WorkspacePersonaToJSONTyped(value?: WorkspacePersona | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'avatarUrl': value['avatarUrl'],
        'type': value['type'],
    };
}

